/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchSummary } from './BatchSummary';
import {
    BatchSummaryFromJSON,
    BatchSummaryFromJSONTyped,
    BatchSummaryToJSON,
    BatchSummaryToJSONTyped,
} from './BatchSummary';

/**
 * 
 * @export
 * @interface BulkDeleteShiftsResponse
 */
export interface BulkDeleteShiftsResponse {
    /**
     * 
     * @type {BatchSummary}
     * @memberof BulkDeleteShiftsResponse
     */
    data: BatchSummary;
}

/**
 * Check if a given object implements the BulkDeleteShiftsResponse interface.
 */
export function instanceOfBulkDeleteShiftsResponse(value: object): value is BulkDeleteShiftsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BulkDeleteShiftsResponseFromJSON(json: any): BulkDeleteShiftsResponse {
    return BulkDeleteShiftsResponseFromJSONTyped(json, false);
}

export function BulkDeleteShiftsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteShiftsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BatchSummaryFromJSON(json['data']),
    };
}

  export function BulkDeleteShiftsResponseToJSON(json: any): BulkDeleteShiftsResponse {
      return BulkDeleteShiftsResponseToJSONTyped(json, false);
  }

  export function BulkDeleteShiftsResponseToJSONTyped(value?: BulkDeleteShiftsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BatchSummaryToJSON(value['data']),
    };
}

